/* tslint:disable */
/* eslint-disable */
/**
 * Aldebaran API
 * API for reporting progress and fetching user info.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetChatMessages200ResponseInner,
  GetProgressReport404Response,
  ReportProgress200Response,
  ReportReactionRequest,
  SendMessageRequest,
} from '../models/index';
import {
    GetChatMessages200ResponseInnerFromJSON,
    GetChatMessages200ResponseInnerToJSON,
    GetProgressReport404ResponseFromJSON,
    GetProgressReport404ResponseToJSON,
    ReportProgress200ResponseFromJSON,
    ReportProgress200ResponseToJSON,
    ReportReactionRequestFromJSON,
    ReportReactionRequestToJSON,
    SendMessageRequestFromJSON,
    SendMessageRequestToJSON,
} from '../models/index';

export interface GetChatMessagesRequest {
    groupId: string;
    chatId: string;
    fromTime?: Date;
    toTime?: Date;
    lastMessageId?: string;
}

export interface ReportReactionOperationRequest {
    reportReactionRequest?: ReportReactionRequest;
}

export interface SendChatMessageRequest {
    sendMessageRequest?: SendMessageRequest;
}

/**
 * 
 */
export class ChatApi extends runtime.BaseAPI {

    /**
     */
    async getChatMessagesRaw(requestParameters: GetChatMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetChatMessages200ResponseInner>>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling getChatMessages().'
            );
        }

        if (requestParameters['chatId'] == null) {
            throw new runtime.RequiredError(
                'chatId',
                'Required parameter "chatId" was null or undefined when calling getChatMessages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['groupId'] != null) {
            queryParameters['groupId'] = requestParameters['groupId'];
        }

        if (requestParameters['chatId'] != null) {
            queryParameters['chatId'] = requestParameters['chatId'];
        }

        if (requestParameters['fromTime'] != null) {
            queryParameters['fromTime'] = (requestParameters['fromTime'] as any).toISOString();
        }

        if (requestParameters['toTime'] != null) {
            queryParameters['toTime'] = (requestParameters['toTime'] as any).toISOString();
        }

        if (requestParameters['lastMessageId'] != null) {
            queryParameters['lastMessageId'] = requestParameters['lastMessageId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/chat/messages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetChatMessages200ResponseInnerFromJSON));
    }

    /**
     */
    async getChatMessages(requestParameters: GetChatMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetChatMessages200ResponseInner>> {
        const response = await this.getChatMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportReactionRaw(requestParameters: ReportReactionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportProgress200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/chat/messages/reaction`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReportReactionRequestToJSON(requestParameters['reportReactionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportProgress200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async reportReaction(requestParameters: ReportReactionOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportProgress200Response> {
        const response = await this.reportReactionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async sendChatMessageRaw(requestParameters: SendChatMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportProgress200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/chat/messages/send`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendMessageRequestToJSON(requestParameters['sendMessageRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportProgress200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async sendChatMessage(requestParameters: SendChatMessageRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportProgress200Response> {
        const response = await this.sendChatMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
